import type { AgreementDetailsStatus } from '@/api/generated/models';
import { Badge } from '@/components/ui/badge';

const statusVariantMap: Record<
  NonNullable<AgreementDetailsStatus>,
  'active' | 'alert' | 'complete'
> = {
  Active: 'active',
  Unfulfilled: 'alert',
  Fulfilled: 'complete',
};

export function AgreementStatusBadge({
  status,
}: {
  status: NonNullable<AgreementDetailsStatus>;
}) {
  return <Badge variant={statusVariantMap[status]}>{status}</Badge>;
}
